// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.rating-slider-content {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
  font-size: 1.5rem;
}

.slider-container {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.slider-container span {
  margin-left: 10px;
}

/* .rating-input {
  width: 90%;
} */

.horizontal-slider {
  width: 100%;
  height: 25px;
}

.rating-thumb {
  line-height: 25px;
  text-align: center;
  background-color: white;
  border-radius: 50%;
  cursor: grab;
  box-shadow: var(--theme-consistent) 0px 0px 5px 0px;
  border: 1px solid var(--theme-consistent);
  height: 24px;
  width: 24px;
}

.rating-track {
  top: 5px;
  bottom: 0;
  box-shadow: var(--theme-consistent) 0px 0px 5px 0px;
  background-color: var(--theme-consistent);
  border-radius: 16px;
  border: 0.2px solid var(--theme-consistent);
  height: 16px;
}

.source-logo-container {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  margin-bottom: 8px;
}

.source-logo-container img {
  height: 30px;
  width: auto;
  margin-right: 5px;
}

/*
.rating-input::-webkit-slider-runnable-track {

}

.rating-input::-moz-range-track {
  width: 100%;
  height: 16px;
  cursor: pointer;
  box-shadow: var(--theme-consistent) 0px 0px 5px 0px;
  background-color: var(--theme-consistent);
  border-radius: 16px;
  border: 0.2px solid var(--theme-consistent);
}

.rating-input::-webkit-slider-thumb {
  box-shadow: var(--theme-consistent) 0px 0px 5px 0px;
  border: 1px solid var(--theme-consistent);
  height: 24px;
  width: 24px;
  border-radius: 50%;
  background: white;
  cursor: pointer;
  -webkit-appearance: none;
  appearance: none;
  margin-top: -5px;
}

.rating-input::-moz-range-thumb {
  box-shadow: var(--theme-consistent) 0px 0px 5px 0px;
  border: 1px solid var(--theme-consistent);
  height: 24px;
  width: 24px;
  border-radius: 50%;
  background: white;
  cursor: pointer;
} */
`, "",{"version":3,"sources":["webpack://./src/assets/RatingSlider.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,iBAAiB;AACnB;;AAEA;;GAEG;;AAEH;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,uBAAuB;EACvB,kBAAkB;EAClB,YAAY;EACZ,mDAAmD;EACnD,yCAAyC;EACzC,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,QAAQ;EACR,SAAS;EACT,mDAAmD;EACnD,yCAAyC;EACzC,mBAAmB;EACnB,2CAA2C;EAC3C,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,2BAA2B;EAC3B,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,iBAAiB;AACnB;;AAEA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;GAoCG","sourcesContent":[".rating-slider-content {\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  height: 100%;\n  font-size: 1.5rem;\n}\n\n.slider-container {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.slider-container span {\n  margin-left: 10px;\n}\n\n/* .rating-input {\n  width: 90%;\n} */\n\n.horizontal-slider {\n  width: 100%;\n  height: 25px;\n}\n\n.rating-thumb {\n  line-height: 25px;\n  text-align: center;\n  background-color: white;\n  border-radius: 50%;\n  cursor: grab;\n  box-shadow: var(--theme-consistent) 0px 0px 5px 0px;\n  border: 1px solid var(--theme-consistent);\n  height: 24px;\n  width: 24px;\n}\n\n.rating-track {\n  top: 5px;\n  bottom: 0;\n  box-shadow: var(--theme-consistent) 0px 0px 5px 0px;\n  background-color: var(--theme-consistent);\n  border-radius: 16px;\n  border: 0.2px solid var(--theme-consistent);\n  height: 16px;\n}\n\n.source-logo-container {\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n  margin-bottom: 8px;\n}\n\n.source-logo-container img {\n  height: 30px;\n  width: auto;\n  margin-right: 5px;\n}\n\n/*\n.rating-input::-webkit-slider-runnable-track {\n\n}\n\n.rating-input::-moz-range-track {\n  width: 100%;\n  height: 16px;\n  cursor: pointer;\n  box-shadow: var(--theme-consistent) 0px 0px 5px 0px;\n  background-color: var(--theme-consistent);\n  border-radius: 16px;\n  border: 0.2px solid var(--theme-consistent);\n}\n\n.rating-input::-webkit-slider-thumb {\n  box-shadow: var(--theme-consistent) 0px 0px 5px 0px;\n  border: 1px solid var(--theme-consistent);\n  height: 24px;\n  width: 24px;\n  border-radius: 50%;\n  background: white;\n  cursor: pointer;\n  -webkit-appearance: none;\n  appearance: none;\n  margin-top: -5px;\n}\n\n.rating-input::-moz-range-thumb {\n  box-shadow: var(--theme-consistent) 0px 0px 5px 0px;\n  border: 1px solid var(--theme-consistent);\n  height: 24px;\n  width: 24px;\n  border-radius: 50%;\n  background: white;\n  cursor: pointer;\n} */\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
